<div class="settings-main-header">
  <div class="settings-header-logo">
    <img src="assets/img/logo/openpay.webp">
  </div>
</div>
